import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { useGetParking } from 'src/features/parkingManagement/api/useGetParking';
import GeneralInfoParkingForm from 'src/features/parkingManagement/components/forms/GeneralInfoParkingForm';
import { parkingManagementMessages } from 'src/features/parkingManagement/utils/messages';
import { GeneralBlockSubtitle, GeneralBlockTitle } from 'src/registry/components/blocks/GeneralBlock';
import { Skeleton } from 'src/registry/ui/Skeleton';

function ParkingDetails() {
    const { parkingId } = useParams();
    const { formatMessage } = useIntl();

    const { data, isLoading, isError, refetch } = useGetParking({
        parkingId: parkingId || '',
        config: { enabled: !!parkingId },
    });

    return (
        <>
            <div className="flex flex-col gap-4 md:gap-6">
                <div className="flex flex-col gap-4 md:flex-row md:gap-6">
                    {isLoading ? (
                        <div className="flex flex-1 flex-col gap-2">
                            <Skeleton className="h-7 w-full max-w-64" />
                            <Skeleton className="h-5 w-full max-w-80" />
                        </div>
                    ) : (
                        <div className="flex flex-col gap-2">
                            <GeneralBlockTitle>
                                {formatMessage(parkingManagementMessages.generalInformation)}
                            </GeneralBlockTitle>
                            <GeneralBlockSubtitle>
                                {formatMessage(parkingManagementMessages.generalInformationDescription)}
                            </GeneralBlockSubtitle>
                        </div>
                    )}
                </div>
                {isLoading ? (
                    <div className="flex flex-col gap-4">
                        <Skeleton className="h-12 w-full max-w-xl" />
                        <Skeleton className="h-12 w-full max-w-xl" />
                        <Skeleton className="h-12 w-full max-w-xl" />
                    </div>
                ) : (
                    data && !isError && <GeneralInfoParkingForm data={data} refetch={refetch} />
                )}
            </div>
        </>
    );
}

export default ParkingDetails;
